// extracted by mini-css-extract-plugin
export default {"DoubleNumber":"DoubleNumber_DoubleNumber__HD+RY","header":"DoubleNumber_header__ve+F2","field":"DoubleNumber_field__rUBj1","divRef":"DoubleNumber_divRef__zUdKf"};